import { StringKey } from '../../../lang/index';

export enum Column {
  CHEVRON = 'chevron',
  PAYOUT_DATE = 'payout-date',
  PAYOUT_NAME = 'payout-name',
  PERIOD = 'period',
  STATUS = 'status',
  TOTAL_DIVIDEND_PAYOUT = 'total-dividend-payout',
}

export enum BreakdownColumn {
  DIVIDEND_PER_SHARE = 'dividend-per-share',
  PAYOUT_FOR_SHARE_CLASS = 'payout-for-share-class',
  SHARE_AMOUNT = 'share-amount',
  SHARE_CLASS = 'share-class',
}

export const columnTranslationKey: Record<Column, StringKey> = {
  [Column.CHEVRON]: 'EMPTY',
  [Column.PAYOUT_NAME]: 'PAYOUT_NAME',
  [Column.PERIOD]: 'PERIOD',
  [Column.PAYOUT_DATE]: 'PAYOUT_DATE',
  [Column.TOTAL_DIVIDEND_PAYOUT]: 'TOTAL_DIVIDEND_PAYOUT',
  [Column.STATUS]: 'STATUS',
};

export const breakdownColumnTranslationKey: Record<BreakdownColumn, StringKey> = {
  [BreakdownColumn.SHARE_CLASS]: 'SHARE_CLASS',
  [BreakdownColumn.DIVIDEND_PER_SHARE]: 'DIVIDEND_PER_SHARE',
  [BreakdownColumn.SHARE_AMOUNT]: 'SHARE_AMOUNT',
  [BreakdownColumn.PAYOUT_FOR_SHARE_CLASS]: 'PAYOUT_FOR_SHARE_CLASS',
};

export const columnOrderMap = Object.keys(columnTranslationKey) as Column[];
export const breakdownColumnOrderMap = Object.keys(
  breakdownColumnTranslationKey,
) as BreakdownColumn[];
